import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import { FormLabel } from '@/components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

/**
 * Country Code field — kept as a text input with an onKeyPress digit guard
 * (matching the old page) rather than the shared NumberField component,
 * since an HTML type="number" input allows spinners/negative/scientific
 * notation input that the old digit-only filter never permitted.
 */
const CountryCodeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.countryCode && touched.countryCode}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Country Code
                </FormLabel>
                <Field
                    name="countryCode"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Please enter a Country Code"
                            onKeyPress={(event) => {
                                if (!/^[0-9]$/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="eg. 1"
                        ariaLabel="country-code-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.countryCode}</FieldError>
        </FormControl>
    );
};

export default CountryCodeField;
